import { type AddressLight } from "shared/apiClient";
import { type LocalisationConfig } from "shared/lib";
import { InvalidAddressType } from "@/variables/globalVar";

import { AddressOutOfScope } from "./AddressOutOfScope";
import { CouncilNotSupported } from "./CouncilNotSupported";
import { DownForMaintenance } from "./DownForMaintenance";
import { AddressError } from "./AddressError";

export interface InvalidAddressProps {
  address: AddressLight | undefined | null;
  localisationConfig: LocalisationConfig | undefined | null;
  mode: InvalidAddressType | undefined;
}

export function InvalidAddress({
  address,
  localisationConfig,
  mode,
}: InvalidAddressProps) {
  const renderCallout = () => {
    switch (mode) {
      case InvalidAddressType.ADDRESS_OUT_OF_SCOPE:
        return (
          <AddressOutOfScope
            address={address}
            localisationConfig={localisationConfig}
          />
        );
      case InvalidAddressType.COUNCIL_NOT_SUPPORTED:
        return (
          <CouncilNotSupported
            address={address}
            localisationConfig={localisationConfig}
          />
        );
      case InvalidAddressType.DOWN_FOR_MAINTENANCE:
        return (
          <DownForMaintenance
            address={address}
            localisationConfig={localisationConfig}
          />
        );
      case InvalidAddressType.TRANSLATION_EXPERT_NOT_FOUND:
        return <AddressError />;
      case InvalidAddressType.TECHNICAL_ERROR:
        return <AddressError />;
    }
  };

  return renderCallout();
}
